<script lang="ts">
	import { goto } from '$app/navigation';
	import { page } from '$app/state';
	import Loading from '$lib/svg/loading.svg.svelte';
	import WidgetPage from '$lib/widget/components/WidgetPage.svelte';
	import { onMount } from 'svelte';

	onMount(() => {
		goto(page.params.hash + '/welcome', { replaceState: true });
	});
</script>

<WidgetPage hideRestartButton>
	<Loading className="flex-none p-5 mt-4 mx-auto" width="w-12" />
</WidgetPage>
